<app-modal title="Set Timeout" size="small" (save)="setTimeout()" #timeout_modal>
    <input type="text" class="form-control" [(ngModel)]="new_timeout">
</app-modal>